export const routes = {
  internal: {
    getGroupsZipCSV: '/internal/campaign-groups/zips-in-use/export',
    addAllCampaignsInGroup: '/internal/campaign-groups/:groupId/campaigns',
    deleteAllCampaignsInGroup: '/internal/campaign-groups/:groupId/campaigns',
    getCampaignsInGrouping: '/internal/campaign-groups/:groupId/service-campaigns',
    addCampaignInGroup: '/internal/campaign-groups/:groupId/campaigns/:campaignId',
    publishGroup: '/internal/campaign-groups/:groupId/publish',
    deleteCampaignFromGroup: '/internal/campaign-groups/:groupId/campaigns/:campaignId',
    getSingleCampaignCSV: '/internal/campaign-groups/:groupId/campaigns/:campaignId/zips-in-use/export',
    getSingleGroupCSV: '/internal/campaign-groups/:groupId/zips-in-use/export',
    getCampaignNetworkCSV: '/internal/campaign-groups/:groupId/ad-networks/:networkId/zips-in-use/export',
    createGroup: '/internal/campaign-groups',
    getAllGroups: '/internal/campaign-groups',
    getCampaignGroupingDetails: '/internal/campaign-groups/:id/campaigns',
    updateGroup: '/internal/campaign-groups/:groupId',
    getSingleGroup: '/internal/campaign-groups/:id',
    deleteDraftGroup: '/internal/campaign-groups/:groupId',
    groupsCounters: '/internal/campaign-groups/counters',
    zipValidation: '/internal/zip-codes/validate',
    getCampaignGroups: '/internal/campaigns/:id/campaign-groups',
  },
};
